function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgNavIconSearch = function SvgNavIconSearch(props) {
  return h("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 18,
    fill: "none",
    viewBox: "0 0 29 18"
  }, props), h("g", {
    clipPath: "url(#a)"
  }, h("path", {
    d: "M17.902 16.491a.4.4 0 0 1 .097.288.54.54 0 0 1-.097.32l-.803.77a.42.42 0 0 1-.321.129.31.31 0 0 1-.289-.129l-4.275-4.267a.45.45 0 0 1-.097-.288v-.481A8.6 8.6 0 0 1 9.9 14.148a7.35 7.35 0 0 1-6.737-.838A7.33 7.33 0 0 1 0 7.313a6.96 6.96 0 0 1 .995-3.656A7.36 7.36 0 0 1 7.327 0a7 7 0 0 1 3.664.995 7.3 7.3 0 0 1 3.224 3.861 7.3 7.3 0 0 1-.042 5.026 7.8 7.8 0 0 1-1.315 2.213h.482a.5.5 0 0 1 .29.097zM7.327 12.964a5.65 5.65 0 0 0 4.878-2.814 5.62 5.62 0 0 0 .006-5.623A5.6 5.6 0 0 0 8.797 1.91a5.63 5.63 0 0 0-4.268.563A5.27 5.27 0 0 0 2.47 4.527a5.65 5.65 0 0 0 0 5.614 5.27 5.27 0 0 0 2.058 2.054c.842.51 1.81.777 2.796.77z"
  })), h("defs", null, h("clipPath", {
    id: "a"
  }, h("path", {
    fill: "#fff",
    d: "M0 0h29v18H0z"
  }))));
};
export default SvgNavIconSearch;